export default __webpack_public_path__ + "static/media/user_3.a3cac54f.svg";